<template>
    <div class="quesnaireFormSetting">
        <div class="left">
            <div class="container">
                <div class="title-box">基础组件</div>
                <div class="boxs">
                    <div class="box" v-for="(obj,index) in baseCompList" :key="index" @click="handleAdd(obj)">
                        <i class="icon" :class="obj.icon"></i>
                        <span>{{obj.typename}}</span>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="title-box">基础组件</div>
                <div class="boxs">
                    <div class="box" v-for="(obj,index) in commonCompList" :key="index" @click="handleAdd(obj)">
                        <i class="icon" :class="obj.icon"></i>
                        <span>{{obj.typename}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <el-form :model="item" :rules="rules" ref="ruleForm1" label-width="0" class="demo-ruleForm">
            <SlickList lockAxis="y" v-model="item.formlist" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                <SlickItem v-for="(obj, index) in item.formlist" :index="index" :key="index" helper-class="listSelect"  class="slickItem" :disabled="isView">
                    <div class="ques-itemBox" ref="itemBox" >
                        <div><el-checkbox v-model="obj.isnotnull" :disabled="isView">必填</el-checkbox></div>
                        <div class="colname">
                            <el-form-item label="" :prop="'formlist.'+ index+'.colname'" :rules='rules.colname'>
                                <el-input v-model.trim="obj.colname" :placeholder="obj.typename" :disabled="isView"></el-input>
                            </el-form-item>
                        </div>
                        <div class="oper-box">
                            <div class="flexbetween" v-if="[1,2,3,4,5,8,9].indexOf(obj.coltype)>-1">
                                <el-form-item label="" :prop="'formlist.'+ index+'.placeholder'" :rules='rules.placeholder'>
                                    <el-input v-model.trim="obj.placeholder" placeholder="可输入提示信息" :disabled="isView"></el-input>
                                </el-form-item>
                                <div class="btn input-btn" @click="handleDel(index)" v-if="!isView"><i class="icon el-icon-error"></i></div>
                            </div>
                            <div class="flexbetween title-box" v-else>
                                <span>选项列表</span>
                                <div class="btn" @click="handleDel(index)" v-if="!isView"><i class="icon el-icon-error"></i></div>
                            </div>
                            <div class="placeholder" v-if="[6,7,8].indexOf(obj.coltype)>-1">
                                <div class="optionsinfo-box flexstart" v-for="(obj2, idx) in obj.optionsinfo" :key="idx">
                                    <el-form-item label="" :prop="'formlist.'+ index+'.optionsinfo.'+idx+'.value'" :rules='rules.colname'>
                                        <el-input v-model.trim="obj2.value" :placeholder="obj2.placeholder" :disabled="isView"></el-input>
                                    </el-form-item>
                                    <div class="btn input-btn" @click="handleDelOption(index, idx)" v-if="!isView && idx>1"><i class="icon icon-ques-del"></i></div>
                                </div>
                                <div class="optionsinfo-box flexstart">
                                    <el-button type="primary" plain @click="handleAddOption(index)" v-if="!isView">添加选项</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SlickItem>
            </SlickList>
            </el-form>
        </div>
    </div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
export default {
    name: 'quesnaireFormSetting',
    props: ['item'],
    data() {
        return {
            // coltype 字段类型：1 单行文本框  2 数字文本框  3 日期选择框  4 邮箱输入框   5 多行文本框  6 单选按钮框   7 多选按钮框  8 下拉选择框  9时间选择框
            // datatype 字段数据类型： 1 文本 2 数字 3 手机号码 4 身份证号码 5 邮箱
            baseCompList: [
                {colinnerid : '', coltype: 1, colname: '', placeholder: '', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-text', typename: '文本框'},
                {colinnerid : '', coltype: 5, colname: '', placeholder: '', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-textarea', typename: '文本描述'},
                {colinnerid : '', coltype: 7, colname: '', placeholder: '', datatype: 1, optionsinfo: [{value: '',placeholder: '请输入选择项'},{value: '',placeholder: '请输入选择项'},{value: '',placeholder: '请输入选择项'}], isnotnull: 0, icon: 'icon-ques-checkbox', typename: '复选框'},
                {colinnerid : '', coltype: 6, colname: '', placeholder: '', datatype: 1, optionsinfo: [{value: '',placeholder: '请输入选择项'},{value: '',placeholder: '请输入选择项'}], isnotnull: 0, icon: 'icon-ques-radio', typename: '单选框'},
                {colinnerid : '', coltype: 8, colname: '', placeholder: '', datatype: 1, optionsinfo: [{value: '',placeholder: '请输入选择项'},{value: '',placeholder: '请输入选择项'}], isnotnull: 0, icon: 'icon-ques-select', typename: '下拉菜单'},
                {colinnerid : '', coltype: 3, colname: '', placeholder: '', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-date', typename: '日期'},
                {colinnerid : '', coltype: 9, colname: '', placeholder: '', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-time', typename: '时间'},
            ],
            commonCompList: [
                {colinnerid : '', coltype: 1, colname: '姓名', placeholder: '请输入姓名', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-name', typename: '姓名'},
                {colinnerid : '', coltype: 6, colname: '性别', placeholder: '请输入性别', datatype: 2, optionsinfo: [{value: '男',placeholder: '请输入选择项'},{value: '女',placeholder: '请输入选择项'}], isnotnull: 0, icon: 'icon-ques-sex', typename: '性别'},
                {colinnerid : '', coltype: 2, colname: '年龄', placeholder: '请输入年龄', datatype: 2, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-age', typename: '年龄'},
                {colinnerid : '', coltype: 1, colname: '公司', placeholder: '请输入公司', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-company', typename: '公司'},
                {colinnerid : '', coltype: 1, colname: '职位', placeholder: '请输入职位', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-post', typename: '职位'},
                {colinnerid : '', coltype: 2, colname: '手机号码', placeholder: '请输入手机号码', datatype: 3, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-tel', typename: '手机号码'},
                {colinnerid : '', coltype: 1, colname: '身份证号', placeholder: '请输入身份证号', datatype: 4, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-idcard', typename: '身份证号'},
                {colinnerid : '', coltype: 1, colname: '微信号', placeholder: '请输入微信号', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-wechat', typename: '微信号'},
                {colinnerid : '', coltype: 1, colname: '地址', placeholder: '请输入地址', datatype: 1, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-addr', typename: '地址'},
                {colinnerid : '', coltype: 4, colname: '邮箱', placeholder: '请输入邮箱', datatype: 5, optionsinfo: '', isnotnull: 0, icon: 'icon-ques-email', typename: '邮箱'},
            ],
            rules: {
                colname: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                value: [
                    {required: true, message: '请输入选择项', trigger: 'blur'}
                ],
                placeholder: [
                    // {required: true, message: '请输入提示语', trigger: 'blur'}
                ]
            },
            isView: this.$route.query.isView == 1 ? true : false
        }
    },
    mounted() {
    },
    methods: {
        handleAdd(obj) {
            if (this.isView) return false
            let item = this._.cloneDeep(obj)
            this.item.formlist.push(item)
        },
        handleDel(index) {
            this.item.formlist.splice(index, 1)
        },
        handleDelOption(index, idx) {
            this.item.formlist[index].optionsinfo.splice(idx, 1)
        },
        handleAddOption(index) {
            this.item.formlist[index].optionsinfo.push({
                value: '',
                placeholder: `请输入选择项`
            })
        },
        validate() {
            this.$refs.ruleForm1.validate((valid, name) => {
                if (valid) {
                    this.$emit('submit')
                }
            })
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SlickList, SlickItem,
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.quesnaireFormSetting {
    display: flex;
    .left{
        background: #F5F5F5;
        border: 1px solid #D8DCE6;
        padding: 15px 20px;
        color: #303133;
        font-size: 14px;
        width: 255px;
        min-width: 255px;
        box-sizing: border-box;
        margin-right: 40px;
        .container{
            .title-box{
                padding-bottom: 15px;
            }
            .boxs{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .box{
                    width: 100px;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    background: #fff;
                    margin-bottom: 15px;
                    cursor: pointer;
                    .icon:before{
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                }
                .box:hover{
                    color: #409EFF;
                }
            }
        }
    }
    .right{

    }
}
.ques-slickList{
    .slickItem{
        cursor: move;
        box-sizing: border-box;
        margin-bottom:10px;
        border: 1px solid $line;
        padding: 10px;
    }
    .slick-select{
        border: 1px dashed $tcolor-blue;
        box-sizing: border-box;
    }
    .slickItem:hover{
        box-sizing: border-box;
        border: 1px solid $tcolor-blue;
        .addComp,.delComp{
            display: inline-block;
        }
    }
}
.slick-select{
    border: 1px dashed $tcolor-blue;
    box-sizing: border-box;
}
.ques-itemBox{
    display: flex;
    color: #999999;
    font-size: 14px;
    .el-icon-error{
        color: #d9d9d9;
    }
    .el-checkbox{
        height: 32px;
        line-height: 32px;
    }
    .el-form-item,.el-form-item__content{
        line-height: 32px;
    }
    .el-input,input{
        height: 32px;
        box-sizing: border-box;
    }
    .title-box{
        color: #303133;
        margin-bottom: 10px;
    }
    .el-input,input{
        width: 280px !important;
    }
    .colname{
        margin: 0 32px;
        .el-input,input{
            width: 128px !important;
        }
    }
    .el-button{
        width: 280px;
    }
    .btn{
        margin-left: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .icon{
            display: flex;
            justify-content: center;
            align-items: center;
            &:before{
                width: 14px;
                height: 14px;
            }
        }
    }
    .btn.input-btn{
        margin-top: -22px;
    }
}
</style>
